import { useCallback } from "react";
import backend from "../backend";

export const useLinkGlue = (
  adventureId: string,
  refreshAll: () => void
) => {
  const addLink = useCallback((from: string, to: string) => {
    (async () => {
      const linkResponse = await backend.link(adventureId, from, to);
      if (!linkResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  const removeLink = useCallback((from: string, to: string) => {
    (async () => {
      const unlinkResponse = await backend.unlink(adventureId, from, to);
      if (!unlinkResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);

  const setParent = useCallback((itemId: string, parentItemId: string) => {
    (async () => {
      const parentResponse = await backend.setParent(adventureId, itemId, parentItemId);
      if (!parentResponse.ok) {
        return;
      }
      refreshAll();
    })();
  }, [adventureId, refreshAll]);
  
  return { addLink, removeLink, setParent };
};